import { render, staticRenderFns } from "./MemberRate.vue?vue&type=template&id=a904886c&scoped=true"
import script from "./MemberRate.vue?vue&type=script&lang=js"
export * from "./MemberRate.vue?vue&type=script&lang=js"
import style0 from "./MemberRate.vue?vue&type=style&index=0&id=a904886c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a904886c",
  null
  
)

export default component.exports